import {
  Box,
  Text,
  Heading,
  Divider,
  Spinner,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
} from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

const ReportSummaryPage = () => {
  const { jobId } = useParams();
  const [data, setData] = useState<string[][]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    fetch(
      `${import.meta.env.VITE_API_URL}/api/v1/pgx/jobs/${jobId}/results/preview?limit=500`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((res) => res.json())
      .then((json) => {
        setData(json.preview as string[][]);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [jobId]);

  if (loading) return <Spinner size="xl" mt={20} />;

  const headers = data.length > 0 ? data[0] : [];
  const rows = data.length > 1 ? data.slice(1) : [];

  // Extract only required columns
  const geneIdx = headers.indexOf("Gene");
  const genotypeIdx = headers.indexOf("Genotype");
  const phenotypeIdx = headers.indexOf("Phenotype");
  const selectedIndexes = [geneIdx, genotypeIdx, phenotypeIdx].filter(
    (idx) => idx !== -1
  );

  return (
    <Box p={8} maxW="90%" mx="auto">
      {/* Title like PGXExtractor */}
      <Heading
        size="lg"
        mb={6}
        textAlign="center"
        bgGradient="linear(to-r, #1a1262, #4f4987)"
        bgClip="text"
      >
        Report Summary
      </Heading>

      <Divider borderColor="surface.300" borderBottomWidth="2px" width="50%" mx="auto" mb={6} />

      <Box borderWidth="1px" borderRadius="2xl" shadow="md" p={6}>
        {data.length ? (
          <TableContainer maxH="500px" overflowY="auto">
            <Table size="sm" variant="striped">
              <Thead
                position="sticky"
                top={0}
                bg="surface.200"
                zIndex={1}
                boxShadow="sm"
              >
                <Tr>
                  {selectedIndexes.map((idx) => (
                    <Th key={idx}>{headers[idx]}</Th>
                  ))}
                </Tr>
              </Thead>
              <Tbody>
                {rows.map((row, i) => (
                  <Tr key={i}>
                    {selectedIndexes.map((idx) => (
                      <Td key={idx}>{row[idx]}</Td>
                    ))}
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        ) : (
          <Text textAlign="center" fontWeight="medium">
            No summary data available.
          </Text>
        )}
      </Box>
    </Box>
  );
};

export default ReportSummaryPage;